import React, { useState } from "react";
import rowSelectIcon from "../../img/rowDownIcon.svg";
import showPassIcon from "../../img/showPassIcon.svg";
import hidePassIcon from "../../img/hidePassIcon.svg";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import Select from "react-select";
import * as Yup from "yup";
import axios, { USER_POST_REGISTRATION } from "../../Api/axios";
import RegModal from "../RegModal/RegModal";
import { useGetCerts } from "../../Api/ApiCerts/axiosGetCerts";

const Reg = () => {
  const [activeShowPass, setActiveShowPass] = useState(true);
  const [regError, setRegError] = useState("");
  const [activeModal, setActiveModal] = useState(false);

  const certs = useGetCerts();

  const formik = useFormik({
    initialValues: {
      login: "",
      password: "",
      firstName: "",
      lastName: "",
      organization_id: 0,
      port_id: 0,
      cert: "",
    },
    validationSchema: Yup.object({
      login: Yup.string()
        .matches(
          /(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u,
          "Is not in correct format!"
        )
        .required("Required field!"),
      password: Yup.string()
        .min(8)
        .matches(
          /(?=.*[0-9])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*]{6,}/g,
          "Is not in correct format!"
        )
        .required("Required field!"),
      firstName: Yup.string()
        .matches(/^([а-яё\s-]+|[a-z\s-]+)$/i, "Is not in correct format!")
        .required("Required field!"),
      lastName: Yup.string()
        .matches(/^([а-яё\s-]+|[a-z\s-]+)$/i, "Is not in correct format!")
        .required("Required field!"),
      cert: Yup.string().required(),
    }),
    onSubmit: (values) => registrationUser(values),
  });

  const registrationUser = async (body) => {
    try {
      await axios.post(USER_POST_REGISTRATION, body, {
        headers: { "Content-Type": "application/json" },
      });
      setActiveModal(true);
    } catch (err) {
      if(err.response.data.includes('already exist')) {
        setActiveModal(false);
        setRegError("User already existis");
      } else {
        setActiveModal(false);
        setRegError("Server not responding");
      }
    }
  };

  return (
    <div className="reg-wrapper">
      <div className="reg-container">
        <form onSubmit={formik.handleSubmit} className="reg-main-block">
          <div className="reg-title-block">
            <h1 className="reg-title-block__title"> Registration</h1>
          </div>
          <div className="reg-user-data-block">
            <label className="reg-user-data-block__email-label">Login</label>
            <input
              className="reg-user-data-block__email-input"
              type={"text"}
              name={"login"}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.login && formik.touched.login ? (
              <p className="reg-main-block__valid-text">
                {formik.errors.login}
              </p>
            ) : null}
            {/*<img src={rowSelectIcon} className="reg-user-data-block__row-icon" alt={'иконка-стрелочка'}/>*/}
          </div>
          <div className="reg-user-data-block">
            <label className="reg-user-data-block__label">Name</label>
            <input
              className="reg-user-data-block__email-input"
              type={"text"}
              name={"firstName"}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.firstName && formik.touched.firstName ? (
              <p className="reg-main-block__valid-text">
                {formik.errors.firstName}
              </p>
            ) : null}
          </div>
          <div className="reg-user-data-block">
            <label className="reg-user-data-block__label">Last name</label>
            <input
              className="reg-user-data-block__email-input"
              type={"text"}
              name={"lastName"}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.errors.lastName && formik.touched.lastName ? (
              <p className="reg-main-block__valid-text">
                {formik.errors.lastName}
              </p>
            ) : null}
          </div>
          <div className="reg-pass-block">
            <label className="reg-user-data-block__label">Пароль</label>
            <input
              type={activeShowPass ? "password" : "text"}
              className="reg-pass-block__pass-input"
              name={"password"}
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <img
              className="reg-pass-block__show-hide-pass"
              onClick={() => setActiveShowPass(!activeShowPass)}
              src={activeShowPass ? showPassIcon : hidePassIcon}
              alt={"иконка пароль"}
            />
            {formik.errors.password && formik.touched.password ? (
              <p className="reg-main-block__valid-text">
                {formik.errors.password}
              </p>
            ) : null}
          </div>
          <div className="reg-pass-block">
            <label className="reg-user-data-block__label">Сертификат</label>
            {certs ? (
              <Select
                options={certs.map((cert) => ({
                  value: cert.subjKeyId,
                  label: cert.subject,
                }))}
                onChange={(newValue) =>
                  formik.setFieldValue("cert", newValue.value)
                }
                styles={{
                  menu: (base) => ({ ...base, width: "min(40rem, 50vw)" }),
                  container: (base) => ({ ...base, width: "100%" }),
                  control: (base) => ({ ...base, width: "100%" }),
                  option: (base) => ({ ...base, wordBreak: "break-all" }),
                }}
              />
            ) : (
              "Loading"
            )}
            {formik.errors.cert && formik.touched.cert ? (
              <p className="reg-main-block__valid-text">{formik.errors.cert}</p>
            ) : null}
          </div>
          <div className="reg-link-block">
            <div className="reg-link-block__check-remember-me">
              <Link to={"/auth"} className="reg-link-block__link-login-page">
                Back to login page
              </Link>
            </div>
          </div>
          <div className="reg-button-enter-block">
            <p className="reg-button-enter-block__error">{regError}</p>
            <button type={"submit"} className="reg-button-enter">
              Register
            </button>
          </div>
        </form>
      </div>
      <RegModal activeModal={activeModal} setActiveModal={setActiveModal} />
    </div>
  );
};
export default Reg;
